import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { PaymentMethod } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodService extends TmsWebBaseEditService<PaymentMethod, PaymentMethod> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('PaymentMethod', $localize`Payment Method`, httpService, notificationService);
  }
}
